import Vue from "vue";

import HttpService from "./services/httpService";

export default {
  install() {
    Vue.use(HttpService);
  }
};
